import * as React from 'react';
import { CommandItem } from './types';
import CommandBarItem from './CommandBarItem';
import { commandBarOptionId } from './useCommandBar';

type Props = {
  title: string;
  items: CommandItem[];
  selectedIndex: number;
  baseIndex: number;
  isLoading?: boolean;
  onSelect: (item: CommandItem) => void;
};

const CommandBarSection: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  items,
  selectedIndex,
  baseIndex,
  isLoading,
  onSelect,
}) => {
  return (
    <div className="command-bar-section" role="group" aria-label={title}>
      <div className="command-bar-section-title">{title}</div>
      {isLoading && (
        <div aria-live="polite" aria-busy="true">
          {[0, 1].map((i) => (
            <div
              className="command-bar-item command-bar-item--skeleton"
              key={i}>
              <span className="command-bar-skeleton command-bar-skeleton--avatar" />
              <span
                className="command-bar-skeleton"
                style={{ width: i === 0 ? '8rem' : '5.5rem' }}
              />
            </div>
          ))}
        </div>
      )}
      {items.map((item, i) => (
        <CommandBarItem
          key={item.id}
          item={item}
          isSelected={selectedIndex === baseIndex + i}
          optionId={commandBarOptionId(baseIndex + i)}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};

export default CommandBarSection;
